import React from "react";

import { ModuleThemeType } from "@brexhq/shared/types/ModuleTheme";
import { FeaturedArticleProps } from "@brexhq/shared/types/modules/BlockRowsModule/BlockRowItems/FeaturedArticleProps";

import { useFilteredArticles } from "../../../hooks/useFilteredArticles/useFilteredArticles";

import { CardStyle } from "./CardStyle";
import { StackStyle } from "./StackStyle";

export const FeaturedArticle: React.FC<{
  data: FeaturedArticleProps;
  theme: ModuleThemeType;
}> = ({ data, theme }) => {
  const featuredArticle = useFilteredArticles(data._key)[0];

  const displayOptions = {
    showExcerpt: data.showExcerpt,
    showArticleGroup: data.showArticleGroup,
  };

  if (data.style === "card") {
    return (
      <CardStyle
        article={featuredArticle}
        parentTheme={theme}
        cardTheme={data.cardTheme}
        displayOptions={displayOptions}
      />
    );
  }
  if (data.style === "stacked") {
    return (
      <StackStyle
        displayOptions={displayOptions}
        theme={theme}
        article={featuredArticle}
      />
    );
  }
  return null;
};
